(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sky-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('.sky-swatch');
  if (!button) return;
  const root = button.closest('.sky-home');
  const color = button.dataset.color;
  root.querySelectorAll('.sky-swatch').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  root.querySelectorAll('[data-panel]').forEach(item => { item.hidden = item.dataset.panel !== color; });
  root.querySelectorAll('[data-details]').forEach(item => { item.hidden = item.dataset.details !== color; if (!item.hidden) root.querySelector('[data-color-name]').textContent = item.dataset.name; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sky-product-story"] && !Shopify.designMode) return;
  try {
    
if (!window.skyRoutineBound) {
  window.skyRoutineBound = true;
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-sky-use]');
    if (!button) return;
    const root = button.closest('[data-sky-routine]');
    root.querySelectorAll('[data-sky-use]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    root.querySelectorAll('[data-sky-use-panel]').forEach(panel => { panel.hidden = panel.dataset.skyUsePanel !== button.dataset.skyUse; });
  });
}

  } catch(e) { console.error(e); }
})();
})();
